<template>
    <div class="footer">
        <div class="ftop flx">
            <div class="fp1 flx">
                <div class="fs1">
                    <div class="fstitle">
                        关于我们
                    </div>
                    <div class="fsItem" @click="toRule(5)">
                        公司简介
                    </div>
                    <div class="fsItem" @click="toRule(15)">
                        联系我们
                    </div>
                </div>
                <div class="fs1">
                    <div class="fstitle">
                        商务合作
                    </div>
                    <div class="fsItem" @click="toRule(16)">
                        广告合作
                    </div>
                    <div class="fsItem" @click="toRule(17)">
                        市场合作
                    </div>
                </div>

                <div class="fs1">
                    <div class="fstitle">
                        电话客服
                    </div>
                    <div class="fsItem">
                        在线客服:{{info.kefu_tel}}
                    </div>
                    <div class="fsItem">
                        在线时间: {{info.kefu_worktime}}
                    </div>
                </div>

                <div class="fs1">
                    <div class="fstitle">
                        更多
                    </div>
                    <div class="fsItem" @click="toRule(1)">
                        服务协议
                    </div>
                    <div class="fsItem" @click="toRule(2)">
                        隐私政策
                    </div>
                    <div class="fsItem" @click="toRule(3)">
                        发布须知
                    </div>
                    <div class="fsItem" @click="toRule(4)">
                        招聘规范
                    </div>
                </div>

                <div class="fs1">
                    <div class="fstitle" style="text-align: center;">
                        官方小程序
                    </div>
                    <div class="fsImg">
                        <img :src="$img(info.xcx_qrcode)" alt="" />
                    </div>
                </div>

                <div class="fs1">
                    <div class="fstitle" style="text-align: center;">
                        关注公众号
                    </div>
                    <div class="fsImg">
                        <img :src="$img(info.gzh_qrcode)" alt="" />
                    </div>

                </div>

                <div class="fs1" style="margin-right: 0;">
                    <div class="fstitle" style="text-align: center;">
                        企业微信客服
                    </div>
                    <div class="fsImg">
                        <img :src="$img(info.kefu_qrcode)" alt="" />
                    </div>

                </div>

            </div>
        </div>
        <div v-text="info.beian" class="fbot" @click="toJump"></div>
    </div>
</template>
<script>
    import {
        getConfig
    } from "@/api/index.js"
    export default {
        name: 'Footer',
        data() {
            return {
                info: {}
            }
        },
        created() {
            let that = this
            that.getConfig()
            let token = localStorage.getItem('token')
            console.log("token", token)
            if (token) {
                that.isLogin = true
            }
        },
        methods: {
            toRule(e) {
                this.$router.push({
                    path: '/rules', // 写路由path
                    query: {
                        type: e,
                        t: Date.now()
                    }
                })
            },
            getConfig() {
                let that = this
                getConfig().then((res) => {
                    if (res.code == 1) {
                        that.info = res.data
                    }
                })
            },
            toJump() {
                window.open('https://beian.miit.gov.cn/#/Integrated/index')
            }
        }
    }
</script>
<style>
    .fbot {
        box-sizing: border-box;
        padding-top: 35px;
        text-align: center;
        font-weight: 500;
        font-size: 12px;
        color: #9CA3AF;
    }

    .fsImg img {
        width: 100%;
        height: 100%;
    }

    .fsImg {
        box-sizing: border-box;
        padding: 6px;
        width: 130px;
        height: 130px;
        background: #FFFFFF;
        border-radius: 8px;
    }

    .fs1 {
        margin-right: 108px;
        flex-shrink: 0;
    }

    .footer {
        width: 100%;
        height: 333px;
        background: #141A27;
    }

    .ftop {
        width: 1460px;
        box-sizing: border-box;
        padding: 56px 0 25px;
        margin: 0 auto;
        border-bottom: 1px solid #4B5563;
    }

    .fstitle {
        font-weight: 500;
        font-size: 20px;
        color: #FFFFFF;
        margin-bottom: 20px;
        text-align: left;
    }

    .fsItem {
        font-weight: 500;
        font-size: 14px;
        color: #D1D5DB;
        margin-bottom: 12px;
        text-align: left;
        cursor: pointer;
    }
</style>